import FilesTable from './FilesTable.js';

export default FilesTable;
